/**
 * Created by zuozhuo on 2018/1/25.
 */
import createBrowserHistory from "history/createBrowserHistory";

const history = createBrowserHistory();

export default history;



// WEBPACK FOOTER //
// ./src/router/history.js